import React from 'react';
import ModernDashboard from '../components/ModernDashboard';

const HomePage = () => {
  return (
    <ModernDashboard />
  );
};

export default HomePage;
